<template>
  <StylistNav />
  <div class="profile-wrapper">
    <div class="profile-card">
      <h2 class="profile-title">Your Profile</h2>
      <p class="profile-subtitle">Manage your account details and password.</p>

      <!-- Global Messages -->
      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>

      <!-- 1. General Profile Details Section -->
      <section class="profile-section">
        <h3 class="section-heading">General Details</h3>
        <form @submit.prevent="handleSaveDetails">
          
          <div class="form-group">
            <label for="full-name">Full Name</label>
            <input type="text" id="full-name" v-model="fullName" required :disabled="isLoading">
          </div>
          
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" id="email" v-model="email" required :disabled="isLoading">
          </div>

          <div class="form-group">
            <label for="phoneNumber">Phone Number</label>
            <input type="text" id="phoneNumber" v-model="phoneNumber" required :disabled="isLoading">
          </div> 

            <div class="form-group">
            <label for="role">Role</label>
            <input type="role" id="role" v-model="role" required :disabled="isLoading">
          </div>
          
          <div class="form-group">
            <label for="new-password">New Password</label>
            <input type="password" id="new-password" v-model="newPassword" required :disabled="isLoading">
          </div>

          <div class="form-group">
            <label for="confirm-password">Confirm New Password</label>
            <input type="password" id="confirm-password" v-model="confirmPassword" required :disabled="isLoading">
          </div>

          <div class="action-group">
            <button type="submit" class="profile-action-btn password-btn" :disabled="isLoading">
              {{ isLoading ? 'Updating...' : 'Update Details' }}
            </button>
          </div>
        </form>
      </section>

    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { apiClient } from '@/services/ApiClient'
import AdminNavbar from '@/components/admin/AdminNavbar.vue'
import StylistNav from '@/components/stylist/StylistNav.vue'

// Base URL for the Flask backend
const API_BASE_URL = 'https://api-afrobraids.inchtechs.com/api/user'; 
const AUTH_STORAGE_KEY = 'salon_auth'
export default {
    name: 'StylistProfile',
    components: {
        StylistNav,
    },
    data() {
        return {
            stylistInData: {}, // Data coming from local storage and login
            
            stylistUpdateData: { // This is the payload data going to backend
                full_name: '',
                email: '',
                phone_number: '',
                password: '',
                role: ''
            },

            //Data in below
            // General Details
            fullName: '',
            email: '',
            phoneNumber:"",
            role: '',

            // Password Change
            newPassword: '',
            confirmPassword: '',

            // State
            errorMessage: '',
            successMessage: '',
            
            // JWT
            access_token: '',
            refresh_token: '',

            isLoading: false,
        };
    },
    created() {
        const stylistInfo = localStorage.getItem("currentStylist")
        let user = JSON.parse(stylistInfo)
        if(!stylistInfo) {
            this.$router.push({ name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        } else if(!user.access_token) {
            this.$router.push({name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        } else {
        this.loadStylistData(); }
    },
    methods: {
        loadStylistData() {
            // 1. Get the authenticated user's ID/Username from storage
            const storedStylistJSON= localStorage.getItem(AUTH_STORAGE_KEY);
            let user = null

            if (storedStylistJSON) {
                try{ 
                    // Parse the JSON string stored by the login component
                    user = JSON.parse(storedStylistJSON)
                } catch(e) {
                    console.error("Error parsing stored user data: ", e)
                }
            } 
            if (user && user.id) {
                // If a user object is found, 
                console.log(`Stylist session loaded for: ${user.username}`)
                /**
                 * {
    "id": 7,
    "username": "Ojong",
    "email": "ojong@mail.com",
    "role": "stylist",
    "access_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc2NDg0MTg4MiwianRpIjoiYjU0MGJhNjEtOTMyYy00NjUxLWJhNjEtNmE2MDMzZGJiOWJjIiwidHlwZSI6ImFjY2VzcyIsInN1YiI6eyJpZCI6Nywicm9sZSI6InN0eWxpc3QifSwibmJmIjoxNzY0ODQxODgyLCJjc3JmIjoiODk2MzRiNzYtNjM3Ni00MDQwLWEzODgtMmEzNzQ2ZWY0ODIzIiwiZXhwIjoxNzY0ODQ1NDgyfQ.UOpyN1qkSKCkkm1GTuwCKJyPOXAI6G9hcHPXo5hohSE",
    "refresh_token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc2NDg0MTg4MiwianRpIjoiMDE1MmRmMmMtNGM1Ny00NWQwLWE4NzktYWNiYTc3YmMzZTkxIiwidHlwZSI6InJlZnJlc2giLCJzdWIiOnsiaWQiOjcsInJvbGUiOiJzdHlsaXN0In0sIm5iZiI6MTc2NDg0MTg4MiwiY3NyZiI6IjEyYzZhNjRiLTliZWItNDBlNC1hZWFmLWQwYzdlZDljMGMyYiIsImV4cCI6MTc2NzQzMzg4Mn0.jQtHUg-UgFSMl91yxkf3rZATZCX_wfLwBRKzqxavtQs"
}
                 */                
                this.stylistInData = user
                this.fullName = user.username || user.full_name
                this.phoneNumber = user.phone_number || ' '
                this.email = user.email
                this.role = user.role
                this.access_token = user.access_token
                console.log("StylistData here", this.stylistInData)
            } else {
                this.$router.push({ name: 'StylistAuthenticate' });
        } 
    },
        // Prepare the data to be submitted to the database
        async handleSaveDetails() {
            this.errorMessage = '';
            this.successMessage = '';

            if (this.newPassword !== this.confirmPassword) {
                this.errorMessage = 'New password and confirmation do not match.';
                return;
            }

            if (this.newPassword.length < 8) {
                this.errorMessage = 'New password must be at least 8 characters long.';
                return;
            }

            this.isLoading = true;

            const stylistID = this.stylistInData.id;
            
            // 2. Prepare Payload (only include password if a change is requested)
            const payload = {
                full_name: this.fullName,
                email: this.email,
                phone_number: this.phoneNumber,
                // the role of the client will always be a client
                role: this.role//this.role 
            };

            if (this.newPassword) {
                payload.password = this.newPassword;
            }

            console.log("Attempting update for Stylist ID:", stylistID);
            console.log("Payload sent to API:", payload);

            try {
                const results = await axios.put(`${API_BASE_URL}/update/${stylistID}`,{
                    payload
                })
               
                // 4. Update Local Storage with the new data
                const updatedStylistData = {
                    ...this.stylistInData,
                    ...results, // Merge the updated fields from the API response
                };
                localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(updatedStylistData));
                
                // Reload data from local storage to reflect changes immediately
                this.loadStylistData(); 

                this.clearPasswordFields();
                this.successMessage = `Successfully Updated ${this.fullName}'s Details!`;
           
            } catch(error) {
                console.error("Failed to update with this message: ", error)
                this.errorMessage = 'Update Failed'
            }finally {
                this.isLoading = false;
                setTimeout(() => { this.errorMessage = ''; this.successMessage = ''; }, 5000);
            }
        },

        clearPasswordFields() {
            this.currentPassword = '';
            this.newPassword = '';
            this.confirmPassword = '';
        }
    }
}
</script>

<style scoped>

.profile-wrapper {
    min-height: calc(100vh - 60px); 
    background-color: var(--color-light); 
    padding: 30px 15px;
    font-family: 'Inter', sans-serif;
}

.profile-card {
    max-width: 650px;
    margin: 30px auto;
    padding: 35px;
    border-radius: 12px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    background-color: white;
    border-top: 5px solid var(--color-gold); /* Gold accent top */
}

.profile-title {
    color: var(--color-dark);
    text-align: center;
    margin-bottom: 5px;
    font-size: 2.2rem;
    font-weight: 800;
}

.profile-subtitle {
    text-align: center;
    color: #777;
    margin-bottom: 30px;
    font-size: 1rem;
}

.section-heading {
    font-size: 1.5rem;
    color: var(--color-maroon);
    border-bottom: 2px solid var(--color-gold); 
    padding-bottom: 8px;
    margin-bottom: 20px;
    font-weight: 700;
}

.form-group {
    margin-bottom: 18px;
}

.form-group label {
    display: block;
    margin-bottom: 6px;
    font-weight: 600;
    color: #333;
    font-size: 0.95rem;
}

.form-group input {
    width: 100%;
    padding: 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 1rem;
    box-sizing: border-box; 
    transition: border-color 0.2s, box-shadow 0.2s;
}

.form-group input:focus {
    border-color: var(--color-maroon);
    outline: none;
    box-shadow: 0 0 0 3px rgba(220, 20, 60, 0.1);
}

.section-divider {
    border: 0;
    height: 1px;
    background-image: linear-gradient(to right, rgba(0, 0, 0, 0), var(--color-earth), rgba(0, 0, 0, 0));
    margin: 30px 0;
}

/* Action Buttons */
.action-group {
    margin-top: 25px;
    text-align: right;
}

.profile-action-btn {
    padding: 10px 25px;
    border: none;
    border-radius: 25px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
}

.save-btn {
    background-color: #A0522D;
    color: white;
}
.save-btn:hover:not(:disabled) {
    background-color: #8d4523;
    transform: translateY(-1px);
}

.password-btn {
    background-color: var(--color-maroon);
    color: white;
}
.password-btn:hover:not(:disabled) {
    background-color: #c0003c;
    transform: translateY(-1px);
}

.profile-action-btn:disabled {
    background-color: #e0e0e0;
    cursor: not-allowed;
}

/* Messages */
.error-message {
    color: #e74c3c;
    background-color: #fde8e8;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #e74c3c;
}

.success-message {
    color: #27ae60;
    background-color: #e6f9ed;
    padding: 10px;
    border-radius: 6px;
    margin-bottom: 20px;
    text-align: center;
    border: 1px solid #27ae60;
}
</style>